import Moment from "moment";

// Filter report data
export const filterReportData = (reportData, reportFields) => {
  const filteredData = reportData.map(data => {
    delete data.__typename;

    data.order_date = data?.order_date
      ? Moment.tz(new Date(data?.order_date), "Asia/Manila").format(
          "YYYY-MM-DD HH:mm:ss"
        )
      : null;

    data.booked_at = data?.booked_at
      ? Moment.tz(new Date(data?.booked_at), "Asia/Manila").format(
          "YYYY-MM-DD HH:mm:ss"
        )
      : null;

    data.shipped_at = data?.shipped_at
      ? Moment.tz(new Date(data?.shipped_at), "Asia/Manila").format(
          "YYYY-MM-DD HH:mm:ss"
        )
      : null;

    data.completed_at = data?.completed_at
      ? Moment.tz(new Date(data?.completed_at), "Asia/Manila").format(
          "YYYY-MM-DD HH:mm:ss"
        )
      : null;

    // convert meters to km
    data.trip_distance = data?.trip_distance / 1000;

    data.ops_firstname = `${data?.ops_firstname}  ${
      data?.ops_lastname === null || data?.ops_lastname === undefined
        ? ""
        : data?.ops_lastname
    }`;
    data.ops_lastname = "";

    // Filters object to remove extra column
    const erase = Object.keys(data).filter(
      e =>
        !Object.keys(reportFields).includes(e) &&
        !Object.keys(reportFields).includes("ops_lastname")
    );

    // Deletes here
    for (const i in erase) {
      if ({}?.hasOwnProperty.call(erase, i)) {
        delete data[`${erase[i]}`];
      }
    }
    return data;
  });

  return filteredData;
};
